module.exports = __webpack_public_path__ + "static/media/flag-signature.svg";